import type { PropsWithChildren } from 'react';
import { useReducer } from 'react';

import ListBox from '@ingka/list-box';
import Pill from '@ingka/pill';
import chevronDownIcon from '@ingka/ssr-icon/paths/chevron-down';
import chevronUpIcon from '@ingka/ssr-icon/paths/chevron-up';
import { isActionKey } from '@repo/utils';

import styles from './styles.module.scss';

interface Props {
    label: string;
    testId?: string;
    disabled?: boolean;
}

export const Filter = ({ label, testId, disabled, children }: PropsWithChildren<Props>) => {
    const [openFilter, toggleOpenFilter] = useReducer((prev) => !prev, false);

    return (
        <div>
            {openFilter && (
                // oxlint-disable-next-line jsx-a11y/control-has-associated-label
                <div
                    className={styles.filter_overlay}
                    onClick={toggleOpenFilter}
                    onKeyDown={(event) => {
                        isActionKey(event.key) && toggleOpenFilter();
                    }}
                    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
                    role="button"
                    tabIndex={0}
                ></div>
            )}
            <Pill
                data-testid={testId}
                size="small"
                label={label}
                trailingIcon={openFilter ? chevronUpIcon : chevronDownIcon}
                selected={openFilter}
                onClick={toggleOpenFilter}
                disabled={disabled ?? false}
            />
            <ListBox className={String(styles.filter_dropdown)} open={openFilter}>
                {children}
            </ListBox>
        </div>
    );
};
